export const isPDF = () => navigator.userAgent.toLowerCase().indexOf('pdf-export') > -1
